import React from 'react';

import { formatPhoneNumber } from 'utils/string-utils';

import { IconPhone } from './icon';
import { HorizontalLayout } from './Layout';
import { Text, TextProps } from './Text';

type PhoneNumberProps = TextProps & {
    phoneNumber: string | undefined;
};

export const PhoneNumber = ({ phoneNumber, ...textProps }: PhoneNumberProps) => {
    if (!phoneNumber) {
        return null;
    }

    return (
        <HorizontalLayout $rowCenter $gap={4}>
            <IconPhone size="micro" />
            <Text {...textProps}>{formatPhoneNumber(phoneNumber)}</Text>
        </HorizontalLayout>
    );
};
